import stc from 'string-to-color';

type RgbColor = { r: number; g: number; b: number };

export function isValidHexColor(hex: string) {
  // Define a regular expression pattern to match valid hex codes
  const hexPattern = /^#([0-9A-F]{3}){1,2}$/i; // i flag makes the regex case-insensitive

  return hexPattern.test(hex);
}

export const generateHexFromString = (str: string) => {
  if (!str || typeof str !== 'string') {
    // console.log('%cinvalid string passed to generateHexFromString:', 'color: tomato', string);
    return 'var(--primary-main)';
  }
  const hex = stc(str.toLowerCase());
  const rgb = hexToRgb(hex);
  if (!rgb) {
    console.log('%c invalid hex generated from string:', str, ' -> ', hex);
    return 'var(--primary-main)';
  }

  // make sure we have enough contrast
  const l = luminance(rgb.r, rgb.g, rgb.b).toFixed(2);
  if (l < 0.066) {
    return shadeColor(hex, (1.5 - l) * 100);
  } else if (l > 0.45) {
    return shadeColor(hex, -(1 - l) * 100);
  }
  return hex;
};

function hexToRgb(hex: string): RgbColor | null {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null;
}

const luminance = (r: number, g: number, b: number): any => {
  const a = [r, g, b].map((v) => {
    const x = v / 255;
    return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
};

const shadeColor = (color: string, percent: number) => {
  let R = parseInt(color.substring(1, 3), 16);
  let G = parseInt(color.substring(3, 5), 16);
  let B = parseInt(color.substring(5, 7), 16);
  R = Math.floor((R * (100 + percent)) / 100);
  G = Math.floor((G * (100 + percent)) / 100);
  B = Math.floor((B * (100 + percent)) / 100);
  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;
  const RR = R.toString(16).length == 1 ? '0' + R.toString(16) : R.toString(16);
  const GG = G.toString(16).length == 1 ? '0' + G.toString(16) : G.toString(16);
  const BB = B.toString(16).length == 1 ? '0' + B.toString(16) : B.toString(16);
  return '#' + RR + GG + BB;
};
